export enum SSO_LOGIN_METHOD {
  DOMAIN = 'domain',
  EMAIL = 'email',
}

export const MEETING_LOGIN_ERR_LIST = ['-90000'];
